export default __webpack_public_path__ + "static/ctm-fa7f16e7dc66f845126a377d4d0d687b.png";